import mock from '@/fake-db/mock.js'

const data = {
  designes: [
    {
      'id': 268,
      'design_name': 'Sophie living',
      'design_slug': 'sophie-living',
      'design_logo': require('@/assets/images/designes/sophie_living_logo.png'),
      'design_visualisation': require('@/assets/images/designes/sophie_living_visualisation.png'),
      'design_cover_img':require('@/assets/images/designes/sophie_living_cover_img.jpg'),
      'email': 'support@sophieiving.com',
      'role': 'admin',
      'status': 'active',
      'is_verified': true,
      'property_type': 'condominium',
      'units_qty': 154,
      'total_area': 8.080,
      'sales_price_range': '4000-5000',
      'company': 'WinDon Technologies Pvt Ltd',
      'mobile': '+65958951757',
      'website': 'https://rowboat.com/insititious/Angelo',
      'languages_known': ['English', 'Arabic'],
      'contact_options': ['email', 'message', 'phone'],
      'location': {
        'add_line_1': 'Kohlmarkt 8-10, 1.OG',
        'add_line_2': '',
        'post_code': 'A-1010',
        'city': 'Vienna',
        'country': 'Austria'
      },
      'social_links': {
        'facebook': 'https://www.facebook.com/sophie-living',
        'instagram': 'https://www.instagram.com/sophie-living/'
      },
      'wishlists': {
        'designes': {
          'read': true,
          'write': false,
          'create': false,
          'delete': false
        },
        'posts': {
          'read': true,
          'write': true,
          'create': true,
          'delete': true
        },
        'comments': {
          'read': true,
          'write': false,
          'create': true,
          'delete': false
        }

      }
    },
    {
      'id': 269,
      'designname': 'demodulation463',
      'avatar': require('@/assets/images/portrait/small/avatar-s-2.jpg'),
      'design_cover_img':require('@/assets/images/designes/sophie_living_cover_img.jpg'),
      'email': 'rubi@ortwein.com',
      'name': 'Rubi Ortwein',
      'country': 'Syria',
      'role': 'design',
      'status': 'inactive',
      'is_verified': false,
    },
    {
      'id': 270,
      'designname': 'demodulation463',
      'avatar': require('@/assets/images/portrait/small/avatar-s-2.jpg'),
      'design_cover_img':require('@/assets/images/designes/sophie_living_cover_img.jpg'),
      'email': 'rubi@ortwein.com',
      'name': 'Rubi Ortwein',
      'country': 'Syria',
      'role': 'design',
      'status': 'archived',
      'is_verified': false,
    },

  ]
}


mock.onGet('/api/design-management/designes').reply(() => {
  return [200, JSON.parse(JSON.stringify(data.designes)).reverse()]
})

// GET: Fetch Single Design Details
mock.onGet(/\/api\/design-management\/designes\/\d+/).reply((request) => {

  const designId = request.url.substring(request.url.lastIndexOf('/') + 1)

  const design = data.designes.find((design) => design.id == designId)

  return design ? [200, JSON.parse(JSON.stringify(design))] : [404]
})

// // POST : Add new Item
// mock.onPost("/api/data-list/products/").reply((request) => {

//   // Get event from post data
//   let item = JSON.parse(request.data).item

//   const length = data.products.length
//   let lastIndex = 0
//   if(length){
//     lastIndex = data.products[length - 1].id
//   }
//   item.id = lastIndex + 1

//   data.products.push(item)

//   return [201, {id: item.id}]
// })

// // Update Product
// mock.onPost(/\/api\/data-list\/products\/\d+/).reply((request) => {

//   const itemId = request.url.substring(request.url.lastIndexOf("/")+1)

//   let item = data.products.find((item) => item.id == itemId)
//   Object.assign(item, JSON.parse(request.data).item)

//   return [200, item]
// })

// // DELETE: Remove Item
mock.onDelete(/\/api\/design-management\/designes\/\d+/).reply((request) => {

  const designId = request.url.substring(request.url.lastIndexOf('/') + 1)

  const itemIndex = data.designes.findIndex((p) => p.id == designId)
  data.designes.splice(itemIndex, 1)
  return [200]
})
